<template>
    <svg
        class="fill-current"
        viewBox="0 0 32 32"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M20.75 11.25V14.5H22.75V11.25L26 11.25V9.25L22.75 9.25V6H20.75V9.25L17.5 9.25V11.25L20.75 11.25Z" />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.9358 8.0127V12.9485C14.9358 14.0531 14.0404 14.9485 12.9358 14.9485H8C6.89543 14.9485 6 14.0531 6 12.9485V8.01269C6 6.90813 6.89543 6.01269 8 6.0127L12.9358 6.0127C14.0404 6.0127 14.9358 6.90813 14.9358 8.0127ZM12.9358 12.9485L12.9358 8.0127L8 8.0127L8 12.9485L12.9358 12.9485Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M14.9358 24.0003V19.0645C14.9358 17.9599 14.0404 17.0645 12.9358 17.0645H8C6.89543 17.0645 6 17.9599 6 19.0645V24.0003C6 25.1049 6.89543 26.0003 8 26.0003H12.9358C14.0404 26.0003 14.9358 25.1049 14.9358 24.0003ZM12.9358 19.0645L12.9358 24.0003H8L8 19.0645H12.9358Z"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M26.0008 19.0645V24.0003C26.0008 25.1049 25.1053 26.0003 24.0008 26.0003H19.0649C17.9604 26.0003 17.0649 25.1049 17.0649 24.0003V19.0645C17.0649 17.9599 17.9604 17.0645 19.0649 17.0645H24.0008C25.1053 17.0645 26.0008 17.9599 26.0008 19.0645ZM24.0008 24.0003V19.0645H19.0649V24.0003H24.0008Z"
        />
    </svg>
</template>
